<div class="row mt-1 mb-5">
    <div class="row">
        <div class="col">
            <h4 class="titulo-pagina">{{ (usuarioAvaliadorFge$ | async) ? 'De acordo com o Questionário para Avaliação de Eficiência Energética - FGEnergia' : '' }} </h4>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary only-screen" [routerLink]="'/questionario-fgenergia/pesquisa'" *ngIf="(usuarioAvaliadorFge$ | async)">Cancelar</button>
            <button class="btn btn-primary only-screen" [disabled]="desabilitarConfirmar()" (click)="confirmar(idQuestionario)" *ngIf="(usuarioAvaliadorFge$ | async) && estado?.id == 1">Confirmar</button>
        </div>
    </div>
    <div *ngIf="exibeParteDeAcordo" class="col">
        <div class="text-center">
            <button type="button" class="btn btn-sm btn-success btn-action" (click)="aprovar()">
                <i class="fa fa-check" style="font-size: 60px; height: 1px"> </i>
                <br> De acordo
            </button>
            <span style="padding-left: 30px;"></span>
            <button type="button" class="btn btn-sm btn-danger btn-action"
                (click)="rejeitar()">
                <i class="fa fa-close" style="font-size: 60px; height: 1px"> </i>
                <br> Não de acordo
            </button>

        </div>

        <div *ngIf="exibeTextoJustificativa" class="row">
            <div class="bn-form-group col-md-12">
                <br>
                <label class="form-label" for="justificativa"><b>Justificativa</b></label>
                <textarea 
                    class="form-control" 
                    name="justificativa" 
                    id="justificativa" 
                    placeholder="Justificativa do não de acordo" 
                    [(ngModel)]="textoJustificativa"
                    minlength="3" 
                    maxlength="970" 
                    rows="3"
                >
                </textarea>
            </div>
        </div>

    </div>

</div>

<div *ngIf="exibeResultadoDaAvaliacao" class="row mt-1">
    <div class="col-md-12">
        <hr>
    </div>
    <div class="col">
        <h5>Resultado da Avaliação</h5>
        <b [ngClass]="{'text-danger' : estado?.id && estado.id == 3 }"> {{ estado?.nomeEstado }} </b>
        <div *ngIf="exibeTextoJustificativa" class="row">
            <div class="bn-form-group col-md-12">
                <br>
                <label class="form-label" for="justificativa"><b>Justificativa</b></label>
                <textarea class="form-control" name="justificativa" id="justificativa" [(ngModel)]="estado.motivoEstado"
                    [disabled]="true" minlength="1" maxlength="1000" rows="3"></textarea>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <hr>
    </div>

</div>

<div class="row mt-3">
    <div class="col">
        <h5>Revisão da Avaliação</h5>
    </div>
</div>


<div>
    <b>Identificação da Empresa Tomadora de Crédito</b>
    <div class="row mt-2">
        <div class="col-md-6">
            <b>CNPJ: </b>
            {{dadosCliente.cnpjCliente | bnMask:'CNPJ'}}
        </div>
        <div class="col-md-6">
            <strong>
                <span *ngIf="dadosCliente.isEsco">
                    A empresa É uma ESCO
                </span>
                <span *ngIf="!dadosCliente.isEsco">
                    A empresa NÃO é uma ESCO
                </span>
            </strong>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-6">
            <b>Representante: </b>
            {{dadosCliente.nomeRepresentante}}
        </div>
        <div class="col-md-6">
            <b>CPF: </b>
            {{dadosCliente.cpfRepresentante | bnMask:'CPF' }}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-3">
            <b>E-mail: </b>
            {{dadosCliente.emailRepresentante}}
        </div>
        <div class="col-md-3">
            <b>Telefone: </b>
            {{dadosCliente.telefoneRepresentante}}
        </div>
        <div class="col-md-3">
            <b>Relação: </b>
            {{dadosCliente.relacaoRepresentante}}
        </div>
    </div>

    <div class="row mt-2" *ngIf="isEmpresaTomadoraDiferente()">
        <div class="col-md-6">
            <b>CNPJ Consumidor beneficiado: </b>
            {{dadosCliente.cnpjBeneficiario | bnMask:'CNPJ'}}
        </div>
        <div class="col-md-6">
            <b>Razão social do Consumidor beneficiado: </b>
            {{dadosCliente.razaoSocialBeneficiario}}
        </div>
    </div>

    <div class="row mt-2" *ngIf="isEmpresaTomadoraDiferente()">
        <div class="col-md-4">
            <b>CEP local implantação: </b>
            {{dadosCliente.cepBeneficiario | bnMask:'CEP'}}
        </div>

        <div class="col-md-4">
            <b>Número logradouro local implantação: </b>
            {{dadosCliente.logradouroBeneficiario}}
        </div>

        <div class="col-md-4">
            <b>Complemento endereço local implantação: </b>
            {{dadosCliente.complementoBeneficiario}}
        </div>
    </div>

    <div class="row mt-2" *ngIf="isEmpresaTomadoraDiferente()">
        <div class="col-md-6">
            <b>Nome contato do representante do Consumidor beneficiado: </b>
            {{dadosCliente.responsavelBeneficiario}}
        </div>
        
        <div class="col-md-6">
            <b>E-mail representante do Consumidor beneficiado: </b>
            {{dadosCliente.emailresponsavelBeneficiario}}
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-md-12">
            <b>Projeto: </b>
            <div class="text-muted">
                <small>{{descricaoProjeto}}</small>
            </div>
        </div>

    </div>
</div>

<div class="mt-3">
    <div *ngFor="let pergunta of listaPerguntas; let i = index;">
        <ng-container *ngIf="!pergunta.grupo && pergunta.id != idPerguntaTecnica">
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <span class="titulo-pergunta">
                        {{pergunta.ordem}} )
                        {{pergunta.tituloPergunta}}
                    </span>
                    <br/>
                    <span class="subtitulo-pergunta">
                        {{pergunta.textoPergunta}}
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="pergunta.grupo && pergunta.frontIsPerguntaNovoGrupo && pergunta.categoria != categoriaEconomia">
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <span class="titulo-pergunta">
                        {{pergunta.grupo.ordem}} )
                        {{pergunta.grupo.titulo}}
                    </span>
                    <br/>
                    <span class="subtitulo-pergunta">
                            {{pergunta.grupo.subtitulo}}
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="pergunta.grupo && pergunta.frontIsPerguntaNovoGrupo && podeMostrarQuestoesEconomia() && pergunta.categoria === categoriaEconomia">
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <span class="titulo-pergunta">
                        {{pergunta.grupo.ordem}} )
                        {{pergunta.grupo.titulo}}
                    </span>
                    <br/>
                    <span class="subtitulo-pergunta">
                            {{pergunta.grupo.subtitulo}}
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="pergunta.grupo && pergunta.categoria != categoriaEconomia">
            <div class="row col-md-12">
                <label class="label-pergunta-grupo">
                    {{pergunta.textoPergunta}}
                </label>
            </div>
        </ng-container>
        <ng-container *ngIf="pergunta.grupo && podeMostrarQuestoesEconomia() && pergunta.categoria === categoriaEconomia">
            <div class="row col-md-12">
                <label class="label-pergunta-grupo">
                    {{pergunta.textoPergunta}}
                </label>
            </div>
        </ng-container>        
        <div *ngIf="exibeRespostasDiferentesDoGrupoEconomia(pergunta)" class="item-resposta text-muted" [innerHTML]="pergunta.frontRespostaAsText"></div>
        <div *ngIf="exibeRespostasParaGrupoEconomia(pergunta)" class="item-resposta text-muted" [innerHTML]="pergunta.frontRespostaAsText"></div>
    </div>
</div>
